import React from 'react';
import {
  HStack,
  VStack,
  Text,
  Pressable,
} from '@gluestack-ui/themed';

interface Submission {
  id: string;
  moduleId: string;
  moduleName: string;
  userName: string;
  dueDate: string;
}

interface SubmissionItemProps {
  submission: Submission;
  onPress: () => void;
  showModuleName?: boolean;
}

const SubmissionItem: React.FC<SubmissionItemProps> = ({
  submission,
  onPress,
  showModuleName = false,
}) => {
  const isOverdue = new Date(submission.dueDate) < new Date();

  return (
    <Pressable
      onPress={onPress}
      p="$2"
      px="$3"
      mx="$2"
      my="$0.5"
      borderRadius="$md"
      $hover={{ bg: '$bgHover' }}
    >
      <VStack space="xs">
        <HStack justifyContent="space-between" alignItems="center">
          <Text
            size="sm"
            fontWeight="medium"
            color="$textHeading"
            flex={1}
            numberOfLines={1}
          >
            {submission.userName}
          </Text>
          <Text
            size="2xs"
            color={isOverdue ? '$statusError' : '$textSubtle'}
            fontWeight={isOverdue ? 'bold' : 'normal'}
          >
            {new Date(submission.dueDate).toLocaleDateString()}
          </Text>
        </HStack>
        {showModuleName && (
          <Text size="xs" color="$textSubtle" numberOfLines={1}>
            {submission.moduleName}
          </Text>
        )}
      </VStack>
    </Pressable>
  );
};

export default SubmissionItem;
